module.exports = "<div ui-view></div>"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/template.html
// module id = ../node_modules/xo-wallet-components/src/add-card/template.html
// module chunks = 0